<ion-menu
  (ionWillClose)="closeFlyout()"
  class="facet-flyout"
  [ngClass]="
    platformType === platformEnum.mobile
      ? 'usf-mobile-flyout'
      : 'usf-desktop-flyout'
  "
>
  <ion-header class="ion-no-border facet-flyout-header">
    <ion-toolbar class="facet-flyout-toolbar">
      <ion-buttons slot="end">
        <ion-button (click)="closeFlyout()" class="flyout-close-button">
          <ion-icon name="close-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
    <ion-text>
      <h2 class="facet-flyout-title">{{ facetFlyoutTitle | translate }}</h2>
    </ion-text>
    <div class="facet-flyout-chips" *ngIf="isLoading === false">
      <ng-container
        *ngFor="
          let value of listFacet?.values | keyvalue;
          let i = index;
          trackBy: trackFacetValueId
        "
      >
        <ng-container
          *ngIf="value?.value?.isSelected"
          class="facet-regular-chip"
        >
          <app-usf-chip
            [clickable]="true"
            [type]="chipTypeEnum.selectedFilter"
            [iconConfig]="{
              rightIcon: true,
              color: '#56821f',
              iconUrl: 'assets/images/filter-selected-close.svg',
            }"
            (clickEmitter)="clearListFacet(value?.value)"
          >
            {{ value?.value?.value | titlecase }}
          </app-usf-chip>
        </ng-container>
      </ng-container>
      <ng-container *ngFor="let facetChip of facetChipViewModels; index as i">
        <ng-container
          *ngIf="facetChip.facet.type === 'regular'"
          class="facet-regular-chip"
        >
          <app-usf-chip
            [clickable]="true"
            [type]="chipTypeEnum.selectedFilter"
            [iconConfig]="{
              rightIcon: true,
              color: '#56821f',
              iconUrl: 'assets/images/filter-selected-close.svg',
            }"
            (clickEmitter)="facetChip.facet.toggleSelect(facetChip.facetValue)"
          >
            {{ facetChip.facetValue.value | titlecase }}
          </app-usf-chip>
        </ng-container>
        <ng-container *ngIf="facetChip.facet.type === 'hierarchical'">
          <ng-container
            *ngFor="let value of facetChip.facet.state.selectedValueAncestry"
          >
            <app-usf-chip
              [clickable]="true"
              [type]="chipTypeEnum.selectedFilter"
              [iconConfig]="{
                rightIcon: true,
                color: '#56821f',
                iconUrl: 'assets/images/filter-selected-close.svg',
              }"
              (clickEmitter)="facetChip.facet.deselectAll()"
              *ngIf="value.state === 'selected'"
            >
              {{ value.value | titlecase }}
            </app-usf-chip>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </ion-header>

  <ion-content class="facet-flyout-content">
    <div class="facet-flyout-loading-state" *ngIf="isLoading === true">
      <div class="facet-flyout-loading-text">
        {{ 'i18n.search.searchFlyout.updatingSelections' | translate }}
      </div>
      <ion-spinner name="circles"></ion-spinner>
    </div>
    <ion-accordion-group
      class="facet-flyout-accordion-group"
      *ngIf="isLoading === false"
      value="{{ currentFacetId }}"
    >
      <div *ngIf="facets.length === 0 && !!listFacet">
        <app-list-facet
          [listFacet]="listFacet"
          (facetList)="handleListFacetCheckboxSelection($event)"
        >
        </app-list-facet>
      </div>
      <div *ngFor="let facet of facets; trackBy: trackFacetId; index as i">
        <div *ngIf="i === 1 && !!listFacet">
          <app-list-facet
            [listFacet]="listFacet"
            (facetList)="handleListFacetCheckboxSelection($event)"
          >
          </app-list-facet>
        </div>
        <div *ngIf="!!facet && facet.type === 'regular'">
          <app-regular-facet
            [controller]="facet"
            (regularFacetsSelected)="handleCheckboxSelection($event)"
            (regularFacetLoadValues)="viewMoreOrLessFacetValues($event)"
            (setCurrentFacetIdEmitter)="setCurrentFacetId($event)"
          >
          </app-regular-facet>
        </div>
        <div *ngIf="!!facet && facet.type === 'hierarchical'">
          <app-category-facet
            [controller]="facet"
            (regularFacetsSelected)="handleCheckboxSelection($event)"
            (setCurrentFacetIdEmitter)="setCurrentFacetId($event)"
          >
          </app-category-facet>
        </div>
      </div>
    </ion-accordion-group>
  </ion-content>

  <ion-footer class="facet-flyout-footer" mode="md" *ngIf="isLoading === false">
    <ion-button (click)="closeAndClearAll()" class="usf-outline-green-button">
      {{ 'i18n.common.clearAll' | translate }}
    </ion-button>
    <ion-button [ngClass]="'usf-fill-green-button'" (click)="closeFlyout()">{{
      'i18n.common.close' | translate
    }}</ion-button>
  </ion-footer>
</ion-menu>
